// extracted by mini-css-extract-plugin
export default {"imgCard":"Admin_imgCard__LVr7S"};